export function schoolYears(now = new Date()) {
  const year = Number(new Intl.DateTimeFormat('en', { timeZone: 'Europe/Amsterdam', year: 'numeric' }).format(now));
  const end = Math.min(9998, Math.max(2028, year + 3));
  return Array.from({ length: end - 2023 + 1 }, (_, index) => {
    const start = 2023 + index;
    return start + '-' + (start + 1);
  });
}
